import { render, staticRenderFns } from "./DraggableColumns.vue?vue&type=template&id=639ba3e2&scoped=true"
import script from "./DraggableColumns.vue?vue&type=script&lang=js"
export * from "./DraggableColumns.vue?vue&type=script&lang=js"
import style0 from "./DraggableColumns.vue?vue&type=style&index=0&id=639ba3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639ba3e2",
  null
  
)

export default component.exports